import axios from 'axios';
import { apiUrl } from './apiUrl';

export const get = number =>
    axios.get(`${apiUrl}/misc/car`, { params: { number }, timeout: 2500 })


// WEBPACK FOOTER //
// ./src/services/smartparking-api/Car.js